import React, { memo } from "react";
import styled from "styled-components";

const CellInput = memo(
  ({ value, onChange, onBlur, onKeyDown, type, currentIndex }) => (
    <Input
      type="text"
      value={value}
      className="input-cell-image-container"
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      autoFocus
      data-cell={`cell-${currentIndex}`}
    />
  )
);

export default CellInput;

const Input = styled.input`
     width: 90%;
    height: 90%;
    fontSize: ${({ type }) => (type === "Letter" ? "24px" : "16px")}};
    textAlign: center;
    color: white;
`;
